import HelpOutline from '@mui/icons-material/HelpOutline'
import { Menu, MenuItem } from '@mui/material'
import { IInvoice, IInvoiceDraft } from 'models/invoices.models'
import { selectActiveWorkspace } from 'lib/helpers/selectors'
import useDialog from 'hooks/Shared/useDialog'
import { useAppSelector } from 'store/hooks'
import {
  ICFDIsContainerProps,
  useCFDIsContainerContext,
} from 'containers/Invoices/CFDIs/CFDIsContainer/CFDIsContainer'
import { TModalIcon } from 'components/Shared/SydDialog/SydDialog'

type TCFDIsTableAdditionalOptionsProps = Pick<
  ICFDIsContainerProps,
  'onRedirect'
>

const CFDIsTableAdditionalOptions = ({
  onRedirect,
}: TCFDIsTableAdditionalOptionsProps) => {
  const {
    activeInvoice,
    downloadInvoiceCancelNoticeQuery,
    downloadInvoiceFilesMutation,
    isCFDIsTab,
    openInfo,
    seeMoreAnchor,
    selectedAddonVersion,
    selectedIsCanceled,
    sendCfdiByEmailMutation,
    deleteInvoiceDraftHandler,
    updateInvoiceFormWithInvoiceDataHandler,
    updateState,
  } = useCFDIsContainerContext()

  const typedInvoice = activeInvoice as IInvoice

  const necessaryId = typedInvoice?.idCfdi

  const dialog = useDialog()

  const activeWorkspace = useAppSelector(selectActiveWorkspace)

  return (
    <Menu
      id="seeMoreMenu"
      className="cfdis-table-additional-options"
      style={openInfo ? { zIndex: 1301 } : undefined}
      anchorEl={seeMoreAnchor}
      open={Boolean(seeMoreAnchor)}
      keepMounted
      onClose={() =>
        updateState(draft => {
          draft.seeMoreAnchor = null
        })
      }>
      {isCFDIsTab && !openInfo && (
        <MenuItem
          onClick={() => {
            updateState(draft => {
              draft.openInfo = true
              draft.seeMoreAnchor = null
            })
          }}>
          Ver información
        </MenuItem>
      )}
      {isCFDIsTab && !typedInvoice?.imported && !!typedInvoice?.uuid && (
        <MenuItem
          onClick={e => {
            e.stopPropagation()
            updateState(draft => {
              draft.relatedDocsDialogOpen = true
              draft.seeMoreAnchor = null
            })
          }}>
          Ver documentos relacionados
        </MenuItem>
      )}
      {isCFDIsTab &&
        !typedInvoice?.imported &&
        !selectedIsCanceled &&
        !!typedInvoice?.uuid && (
          <MenuItem
            onClick={e => {
              e.stopPropagation()
              !!necessaryId &&
                onRedirect(
                  'addPaymentComplement',
                  necessaryId,
                  selectedAddonVersion
                )
            }}>
            Nuevo complemento de pago
          </MenuItem>
        )}
      {isCFDIsTab &&
        !typedInvoice?.imported &&
        !selectedIsCanceled &&
        !!typedInvoice?.uuid && (
          <MenuItem
            onClick={e => {
              e.stopPropagation()
              !!necessaryId && onRedirect('addCreditNote', necessaryId)
            }}>
            Nueva nota de crédito
          </MenuItem>
        )}
      {isCFDIsTab && !typedInvoice?.imported && !!typedInvoice?.uuid && (
        <MenuItem
          onClick={e => {
            e.stopPropagation()
            typedInvoice && sendCfdiByEmailMutation.mutate(typedInvoice)
          }}>
          Enviar CFDI por correo
        </MenuItem>
      )}
      {isCFDIsTab && !!typedInvoice?.uuid && (
        <MenuItem
          onClick={e => {
            e.stopPropagation()
            typedInvoice &&
              downloadInvoiceFilesMutation.mutate({
                activeWorkspace,
                activeInvoice: typedInvoice,
              })
          }}>
          Descargar CFDI
        </MenuItem>
      )}
      {isCFDIsTab && !typedInvoice?.imported && !selectedIsCanceled && (
        <MenuItem
          onClick={async e => {
            e.stopPropagation()
            const resp = await dialog.dangerAsync({
              title: '¿Estás seguro?',
              subtitle: 'Estás a punto de cancelar uno de tus CFDIs',
              icon: HelpOutline as TModalIcon,
              primaryButtonText: 'Si, cancelar',
              secondaryButtonText: 'No, cerrar',
            })
            if (!resp) return
            updateState(draft => {
              draft.seeMoreAnchor = null
            })
            typedInvoice &&
              updateState(draft => {
                draft.cancelCFDIDialogOpen = true
              })
          }}>
          Cancelar CFDI
        </MenuItem>
      )}
      {isCFDIsTab && !typedInvoice?.imported && selectedIsCanceled && (
        <MenuItem
          onClick={e => {
            e.stopPropagation()
            typedInvoice && downloadInvoiceCancelNoticeQuery.refetch()
          }}>
          Descargar acuse de cancelación
        </MenuItem>
      )}

      {!isCFDIsTab && (
        <MenuItem onClick={updateInvoiceFormWithInvoiceDataHandler}>
          Continuar CFDI
        </MenuItem>
      )}
      {!isCFDIsTab && activeInvoice && (
        <MenuItem
          onClick={deleteInvoiceDraftHandler(
            activeWorkspace,
            (activeInvoice as IInvoiceDraft).idRequest
          )}>
          Eliminar borrador
        </MenuItem>
      )}
    </Menu>
  )
}

export default CFDIsTableAdditionalOptions
